import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";

// Busqueda de Userprofileorganization
export const findProfileOrganization = createAsyncThunk(
  "userProfileOrganization/findProfileOrganization",
  async (
    { userId, profileId }: { userId: string | undefined; profileId: string | undefined },
    { rejectWithValue }
  ) => {
    try {
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      const result = await fetch(
        `${api.baseURL}userprofileOrganization?populate=organization&where={"user":"${userId}","profile":"${profileId}"}&limit=1000`,
        {
          method: "GET",
          headers: headers,
        }
      );
      const data = await result.json();
      return data as [];
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
